export default __webpack_public_path__ + "images/assets/f46e36acfa8022ab76c4603dff4f6f75.svg";